module.exports = __webpack_public_path__ + "static/media/icon-cart.e4f61bbd.svg";